import React, {useState, useEffect} from 'react';
import {
    Backdrop,
    BackdropProps,
    CircularProgress,
    Container,
    Grid,
    Paper,
} from '@mui/material';
import '../../componentCss/Loading.scss';

export const Spinner = (props) => (
    <div className="spinner-pulse">
        <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
);

export const CenteredSpinner = () => {
    return (
        <Grid container justifyContent="center">
            <Grid item>
                <Spinner></Spinner>
            </Grid>
        </Grid>
    );
};

export const FullScreenLoading = ({show}) => {
    const [delayShow, setDelayShow] = useState(false);
    useEffect(() => {
        setDelayShow(false);
        const timeout = setTimeout(() => setDelayShow(true), 500);
        return () => clearTimeout(timeout);
    }, [show]);

    return (
        <div>
            <div
                className={`spinner-fs-background${
                    show && delayShow ? ' show' : ''
                }`}></div>
            <div
                className={`spinner-fs-foreground${
                    show && delayShow ? ' show' : ''
                }`}>
                <Spinner></Spinner>
            </div>
        </div>
    );
};

export const Loading = ({
    children,
    promise,
    loadingComponent = () => <CenteredSpinner></CenteredSpinner>,
}) => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let cancel = false;

        const f = async (cancel) => {
            try {
                await promise(cancel);
            } catch (error) {
                console.log(error);
            }

            setLoading(false);
        };

        f(cancel);

        return () => {
            cancel = false;
        };
    }, []);

    if (loading) {
        return loadingComponent();
    }

    return children;
};

interface ControlledLoadingProps {
    children?;
    loading: boolean;
    loadingComponent?: () => React.ReactNode;
}

export const ControlledLoading = ({
    loading,
    children = null,
    loadingComponent = () => <LoadingSpinner></LoadingSpinner>,
}: ControlledLoadingProps) => {
    if (loading) {
        return loadingComponent();
    }

    return children ?? <></>;
};

export const LoadingSpinner = () => {
    return (
        <Container>
            <Paper>
                <CenteredSpinner />
            </Paper>
        </Container>
    );
};

//Wrapper for Material UI Backdrop and Circular Spinner so we only need to define "open" prop
export const OverlaySpinner = (props: BackdropProps) => {
    return (
        <Backdrop
            sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
            {...props}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};
